import React from 'react';
export function OEMPartsSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 flex flex-col" data-id="element-3026">
      <h2 className="text-2xl font-bold text-[#1967a5] mb-6 border-b border-gray-200 pb-4" data-id="element-3027">
        OEM Parts/Wire/Consumables
      </h2>
      <div className="space-y-4 text-gray-700 text-lg leading-relaxed flex-grow" data-id="element-3028">
        <p data-id="element-3029">
          The replacement parts and consumables that you use on your machine can
          help or hurt you depending on whom you buy them from. Saving money on
          some items is a good thing - but not if it causes accuracy or
          reliability problems. Certain parts and materials were OEM designed
          specifically for each model of machine. Check with your OEM
          application support or service engineers to make sure that you are not
          chasing a problem of poor performance or accuracy just because of a
          $20 part.
        </p>
      </div>
      <div className="pt-6 mt-auto" data-id="element-3030">
        <a href="/QuoteEDMConsumables.html" className="text-orange hover:underline font-bold text-lg" data-id="element-3031">
          Request a consumables quote today! →
        </a>
      </div>
    </div>;
}